import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { Box } from '@mui/material';
import { Roles } from '../../constants/Roles';

interface Props {
  selection(roles: string[]): void;
  userRoles: string[];
  showAllRoles?: boolean;
  options?: string[];
  isRequired?: boolean;
  variant?: 'standard' | 'outlined' | 'filled';
  size?: 'small' | 'medium';
  required?: boolean;
}

function RolesAutoComplete({
  selection,
  userRoles,
  showAllRoles,
  options,
  isRequired = false,
  variant = 'standard',
  size = 'medium',
  required = false,
}: Props) {
  const [open, setOpen] = useState(false);
  const [availableRoles, setAvailableRoles] = useState<string[]>([]);
  const [selectedRoles, setSelectedRoles] = useState<string[]>([]);
  const loading = open;

  const hasError = isRequired && selectedRoles.length === 0;

  useEffect(() => {
    if (userRoles) {
      setSelectedRoles(userRoles);
    }

    if (showAllRoles) {
      setAvailableRoles(options ?? Roles);
    } else {
      setAvailableRoles(options ?? Roles);
    }
  }, [userRoles, showAllRoles, options]);

  const onOpen = () => {
    setOpen(true);
  };

  const updateSelectedRoles = (values: string[]) => {
    setSelectedRoles(values);
    selection(values);
  };

  return (
    <Box>
      <Autocomplete
        multiple
        open={open}
        disableClearable={true}
        value={selectedRoles}
        onOpen={onOpen}
        onClose={() => {
          setOpen(false);
        }}
        onChange={(option, values) => {
          updateSelectedRoles(values);
        }}
        size={size}
        isOptionEqualToValue={(option, value) => option === value}
        getOptionLabel={(option) => option}
        options={[...selectedRoles, ...availableRoles]}
        loading={loading}
        filterSelectedOptions={true}
        renderInput={(params) => (
          <TextField
            {...params}
            required={required && selectedRoles.length === 0}
            label="Roles"
            error={hasError}
            helperText={hasError ? 'Required' : ''}
            variant={variant}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    </Box>
  );
}
export default RolesAutoComplete;
